import _ from "lodash";
import { takeLatest, call, put } from "redux-saga/effects";
import { fetchCommentCountByResolutionSummary } from "../../../services/comments";
import * as actions from "../commentActions";

export default function* fetchCommentCountByResolutionSummaryWatcher() {
  yield takeLatest(
    actions.FETCH_COMMENT_COUNT_BY_CLOSING_ID,
    fetchCommentCountByResolutionSummaryWorker,
  );
}

export function* fetchCommentCountByResolutionSummaryWorker(action) {
  yield put(actions.loading(true));
  try {
    const response = yield call(fetchCommentCountByResolutionSummary, {
      doc_category_id: action.doc_category_id,
      comment_seq_nbr: action.comment_seq_nbr
    });
    yield call(success, response);
  } catch (error) {
    yield call(failure, error);
  }
}


export function* success(response) {
  yield put(actions.loading(false));

  
  const data = _.get(
    response,
    "data.fetchCategoryCommentResponseCount.count",
    0,
  );

  yield put(actions.setCountResolutionSummaryForProject(data));
}

export function* failure(error) {
  yield put(actions.loading(false));
  yield put(actions.error(error));
}
